var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "right-body", attrs: { id: "shareList" } },
    [
      _c("div", { attrs: { id: "rightBo" } }),
      _vm._v(" "),
      _c("div", { staticClass: "shares-up" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pathJson.length > 0,
                expression: "pathJson.length>0"
              }
            ],
            attrs: { id: "navigation" }
          },
          [
            _c("div", { staticClass: "navigation-path" }, [
              _c("table", [
                _c("tr", [
                  _c("div", {
                    staticClass:
                      "icon-util my-share-icon home-icon-position my-share-click",
                    class: _vm.myShare ? "my-share-click" : "save-share-click",
                    on: {
                      click: function($event) {
                        return _vm.toHomePage()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _c(
                      "td",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.myShare,
                            expression: "myShare"
                          }
                        ],
                        staticClass: "name-desc-one name-desc",
                        on: {
                          click: function($event) {
                            return _vm.toHomePage()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.shares.myShares")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.saveShare,
                            expression: "saveShare"
                          }
                        ],
                        staticClass: "name-desc-one name-desc",
                        on: {
                          click: function($event) {
                            return _vm.toHomePage()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.shares.savedShares")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", {
                    staticClass:
                      "icon-util separate_icon separate-icon-position"
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { float: "left", "line-height": "18Px" } },
                    _vm._l(_vm.pathJson, function(path, index) {
                      return _c("span", { key: index }, [
                        index
                          ? _c("td", {
                              staticClass:
                                "icon-util separate_icon separate-icon-position",
                              attrs: { id: index }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            class: {
                              "text-bold": index == _vm.pathJson.length - 1,
                              "name-desc-one": index == 0,
                              "name-desc":
                                _vm.pathJson.length != 0 &&
                                index != _vm.pathJson.length - 1 &&
                                _vm.pathJson.length > 1 &&
                                path.id != "addEllipsis",
                              "add-Ellipsis": path.id == "addEllipsis"
                            },
                            attrs: { title: path.name },
                            on: {
                              click: function($event) {
                                return _vm.comeBackFile($event, path, index)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm._f("ellipsisNavi")(path.fileName))
                            )
                          ]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.pathJson.length > 0,
                expression: "!pathJson.length>0"
              }
            ],
            staticClass: "share-all"
          },
          [
            _c(
              "div",
              {
                ref: "myShareTab",
                staticClass: "my-share",
                on: {
                  click: function($event) {
                    return _vm.clickTabTitle(0)
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "icon-util my-share-icon my-share-icon-position",
                  class: _vm.myShare ? "my-share-click" : "my-share-icon"
                }),
                _vm._v(" "),
                _c(
                  "span",
                  { class: _vm.myShare ? "share-color-click" : "share-color" },
                  [_vm._v(_vm._s(_vm.$t("language.shares.myShares")))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "saveShareTab",
                staticClass: "save-shares",
                on: {
                  click: function($event) {
                    return _vm.clickTabTitle(1)
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "icon-util save-share-icon-position",
                  class: _vm.saveShare ? "save-share-click" : "save-share-icon"
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    class: _vm.saveShare ? "share-color-click" : "share-color"
                  },
                  [_vm._v(_vm._s(_vm.$t("language.shares.savedShares")))]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", {
              ref: "shareTabBar",
              staticClass: "share-tab-bar",
              style: {
                width: _vm.shareTabBarWidth,
                transform: "translateX(" + _vm.shareTabBarTransform + ")"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "menuList",
            staticClass: "menu-bar",
            class: [_vm.searchResultShow ? "menu-bar-search" : ""]
          },
          [
            _vm.selectItemArr.length
              ? _c(
                  "div",
                  {
                    ref: "menuButtonList",
                    staticClass: "menu-button button-border-all"
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.myShare,
                            expression: "myShare"
                          }
                        ],
                        staticStyle: { position: "relative" }
                      },
                      [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.judgeShowLeftMenu("cancel"),
                                expression: "judgeShowLeftMenu('cancel')"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("cancel")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.cancelShareDialgOpen()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(1) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "cancel icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.common.cancel"))
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.judgeShowLeftMenu("edit_share"),
                                expression: "judgeShowLeftMenu('edit_share')"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("edit_share")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.shareDialgOpen()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(2) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "edit-share icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.editShare")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.judgeShowLeftMenu("download"),
                                expression: "judgeShowLeftMenu('download')"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("download")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: { click: _vm.download }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(3) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "down-load icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.download")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.judgeShowLeftMenu("preview"),
                                expression: "judgeShowLeftMenu('preview')"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("preview")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: { click: _vm.previewPageShow }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(4) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "preview icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.preview")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showToSource("to_source"),
                                expression: "showToSource('to_source')"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("to_source")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.toSource()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(5) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "copy-to icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.toSource")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.judgeShowLeftMenu("to_share"),
                                expression: "judgeShowLeftMenu('to_share')"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("to_share")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.goTo()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(6) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "copy-to icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.toShare")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "clickoutside",
                                rawName: "v-clickoutside",
                                value: _vm.topRightMenuShowClose,
                                expression: "topRightMenuShowClose"
                              },
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.judgeShowLeftMenu("more") && _vm.showMore,
                                expression:
                                  "judgeShowLeftMenu('more')&&showMore"
                              }
                            ],
                            staticClass: "single-button button-border",
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.topRightMenuShow()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(7) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "more more-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.common.more"))
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.moreChooseShow,
                                    expression: "moreChooseShow"
                                  }
                                ],
                                staticClass: "more-items-choose",
                                style: { width: _vm.getTextWidth(12) }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.judgeShowLeftMenu(
                                          "more_preview"
                                        ),
                                        expression:
                                          "judgeShowLeftMenu('more_preview')"
                                      }
                                    ],
                                    staticClass: "more-item-choose",
                                    on: {
                                      click: function($event) {
                                        return _vm.previewPageShow()
                                      }
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "preview item-position preview-position"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "menu-txt" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.preview")
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showToSource(
                                          "more_to_source"
                                        ),
                                        expression:
                                          "showToSource('more_to_source')"
                                      }
                                    ],
                                    staticClass: "more-item-choose",
                                    on: {
                                      click: function($event) {
                                        return _vm.toSource()
                                      }
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "copy-to item-position preview-position"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "menu-txt" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.toSource")
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.judgeShowLeftMenu(
                                          "more_to_share"
                                        ),
                                        expression:
                                          "judgeShowLeftMenu('more_to_share')"
                                      }
                                    ],
                                    staticClass: "more-item-choose",
                                    on: {
                                      click: function($event) {
                                        return _vm.goTo()
                                      }
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "copy-to item-position preview-position"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "menu-txt" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.toShare")
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.judgeShowLeftMenu("more_preview") &&
                                  !_vm.showMore,
                                expression:
                                  "judgeShowLeftMenu('more_preview')&&!showMore"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("more_preview")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.previewPageShow()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(4) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "preview icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.preview")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.showToSource("more_to_source") &&
                                  !_vm.showMore,
                                expression:
                                  "showToSource('more_to_source')&&!showMore"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("more_to_source")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.toSource()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(5) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "copy-to icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.toSource")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.judgeShowLeftMenu("more_to_share") &&
                                  !_vm.showMore,
                                expression:
                                  "judgeShowLeftMenu('more_to_share')&&!showMore"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("more_to_share")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.goTo()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(6) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "copy-to icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.toShare")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.saveShare,
                            expression: "saveShare"
                          }
                        ]
                      },
                      [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.judgeShowLeftMenu("copy_to"),
                                expression: "judgeShowLeftMenu('copy_to')"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("copy_to")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.copyToDialogShow()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(8) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "copy-to icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.common.copyTo"))
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.judgeShowLeftMenu("download"),
                                expression: "judgeShowLeftMenu('download')"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("download")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.download()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(3) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "down-load icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.download")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.judgeShowLeftMenu("preview"),
                                expression: "judgeShowLeftMenu('preview')"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("preview")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.previewPageShow()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(4) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "preview icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.preview")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.judgeShowLeftMenu("copy"),
                                expression: "judgeShowLeftMenu('copy')"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("copy")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.copyFile()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(10) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "copy icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.common.copy"))
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.judgeShowLeftMenu("remove"),
                                expression: "judgeShowLeftMenu('remove')"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("remove")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.cancelShare()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(9) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "remove icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.leftBanner.remove")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.judgeShowLeftMenu("copy_link"),
                                expression: "judgeShowLeftMenu('copy_link')"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("copy_link")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.copy()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(11) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "copy-link icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.copyLink")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.judgeShowLeftMenu("to_share"),
                                expression: "judgeShowLeftMenu('to_share')"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("to_share")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.goTo()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(6) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "copy-to icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.toShare")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "clickoutside",
                                rawName: "v-clickoutside",
                                value: _vm.topRightMenuShowClose,
                                expression: "topRightMenuShowClose"
                              },
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.judgeShowLeftMenu("more") && _vm.showMore,
                                expression:
                                  "judgeShowLeftMenu('more')&&showMore"
                              }
                            ],
                            staticClass: "single-button button-border",
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.topRightMenuShow()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(7) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "more more-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.common.more"))
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.moreChooseShow,
                                    expression: "moreChooseShow"
                                  }
                                ],
                                staticClass: "more-items-choose",
                                style: { width: _vm.getTextWidth(12) }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.judgeShowLeftMenu(
                                          "more_preview"
                                        ),
                                        expression:
                                          "judgeShowLeftMenu('more_preview')"
                                      }
                                    ],
                                    staticClass: "more-item-choose",
                                    on: {
                                      click: function($event) {
                                        return _vm.previewPageShow()
                                      }
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "preview item-position preview-position"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "menu-txt" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.preview")
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.judgeShowLeftMenu(
                                          "more_copy"
                                        ),
                                        expression:
                                          "judgeShowLeftMenu('more_copy')"
                                      }
                                    ],
                                    staticClass: "more-item-choose",
                                    on: {
                                      click: function($event) {
                                        return _vm.copyFile()
                                      }
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "copy item-position preview-position"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "menu-txt" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.common.copy"))
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.judgeShowLeftMenu(
                                          "more_copy_link"
                                        ),
                                        expression:
                                          "judgeShowLeftMenu('more_copy_link')"
                                      }
                                    ],
                                    staticClass: "more-item-choose",
                                    on: { click: _vm.copy }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "copy-link item-position preview-position"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "menu-txt" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.copyLink")
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.judgeShowLeftMenu(
                                          "more_to_share"
                                        ),
                                        expression:
                                          "judgeShowLeftMenu('more_to_share')"
                                      }
                                    ],
                                    staticClass: "more-item-choose",
                                    on: {
                                      click: function($event) {
                                        return _vm.goTo()
                                      }
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "copy-to item-position preview-position"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "menu-txt" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.toShare")
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.judgeShowLeftMenu("more_preview") &&
                                  !_vm.showMore,
                                expression:
                                  "judgeShowLeftMenu('more_preview')&&!showMore"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("more_preview")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.previewPageShow()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(4) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "preview icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.preview")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.judgeShowLeftMenu("more_copy") &&
                                  !_vm.showMore,
                                expression:
                                  "judgeShowLeftMenu('more_copy')&&!showMore"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("more_copy")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.copyFile()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(10) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "copy icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.common.copy"))
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.judgeShowLeftMenu("more_copy_link") &&
                                  !_vm.showMore,
                                expression:
                                  "judgeShowLeftMenu('more_copy_link')&&!showMore"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("more_copy_link")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.copy()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(11) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "copy-link icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.copyLink")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.judgeShowLeftMenu("more_to_share") &&
                                  !_vm.showMore,
                                expression:
                                  "judgeShowLeftMenu('more_to_share')&&!showMore"
                              }
                            ],
                            staticClass: "single-button",
                            class: [
                              _vm.judgeShowLeftMenuBorder("more_to_share")
                                ? ""
                                : "button-border"
                            ],
                            style: { width: _vm.getWidth() },
                            on: {
                              click: function($event) {
                                return _vm.goTo()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "button-center-position",
                                  style: { width: _vm.getTextWidth(6) }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "copy-to icon-position more-white-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "share-operating " },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.toShare")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.selectItemArr.length < 1
              ? _c("div", { staticClass: "menu-button" }, [
                  _c("div", [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.myShare,
                            expression: "myShare"
                          }
                        ],
                        staticClass: "no-manage-share"
                      },
                      [_vm._v(_vm._s(_vm.$t("language.share.noManageMyShare")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.saveShare,
                            expression: "saveShare"
                          }
                        ],
                        staticClass: "no-manage-share"
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("language.share.noManageSavedShare"))
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "share-icons",
                attrs: { onselectstart: "return false" }
              },
              [
                !_vm.searchResultShow
                  ? _c("div", {
                      staticClass:
                        "icon-util refresh cloud-exploer-refresh refresh-position",
                      attrs: {
                        "data-title": _vm.$t("language.cloudExploer.reFresh")
                      },
                      on: {
                        click: function($event) {
                          return _vm.refresh()
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.listShow,
                      expression: "listShow"
                    }
                  ],
                  staticClass: "list refresh-position",
                  attrs: { "data-title": _vm.$t("language.cloudExploer.grid") },
                  on: {
                    click: function($event) {
                      return _vm.gridSwitch()
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.listShow,
                      expression: "!listShow"
                    }
                  ],
                  staticClass: "icon-util grid refresh-position",
                  attrs: {
                    "data-title": _vm.$t("language.cloudExploer.pageList")
                  },
                  on: {
                    click: function($event) {
                      return _vm.gridSwitch()
                    }
                  }
                })
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "share-body" }, [
        _vm.listShow
          ? _c("div", { staticClass: "my-shares-table" }, [
              _c("div", [
                _c(
                  "table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { border: "0", cellpadding: "0", cellspacing: "0" }
                  },
                  [
                    _c("tr", { staticClass: "table-th" }, [
                      _c(
                        "td",
                        {
                          staticClass: "cloud-td-one-share",
                          style: _vm.myShare ? "" : "width:52%",
                          on: {
                            click: function($event) {
                              return _vm.changeUpDownOrder(0)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "tr-check-box",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.selectAll()
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "icon-util icon-tr-position",
                                class: this.isAllSelected
                                  ? "check-small"
                                  : "nocheck-small"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "th-span" }, [
                            _vm._v(_vm._s(_vm.$t("language.common.fileName")))
                          ]),
                          _vm._v(" "),
                          _vm.index == 0
                            ? _c("div", {
                                staticClass:
                                  "icon-util file-narrow-position narrow-position",
                                class: _vm.upShow
                                  ? "file-up-narrow"
                                  : "file-down-narrow"
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "cloud-td-two",
                          style: _vm.myShare ? "" : "width:16%",
                          on: {
                            click: function($event) {
                              return _vm.changeUpDownOrder(3)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("language.common.type")))
                          ]),
                          _vm._v(" "),
                          _vm.index == 3
                            ? _c("div", {
                                staticClass: "icon-util narrow-position-two",
                                class: _vm.upShow
                                  ? "file-up-narrow"
                                  : "file-down-narrow"
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "cloud-td-two",
                          style: _vm.myShare ? "" : "width:16%",
                          on: {
                            click: function($event) {
                              return _vm.changeUpDownOrder(1)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("language.common.size")))
                          ]),
                          _vm._v(" "),
                          _vm.index == 1
                            ? _c("div", {
                                staticClass: "icon-util narrow-position-two",
                                class: _vm.upShow
                                  ? "file-up-narrow"
                                  : "file-down-narrow"
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "cloud-td-two",
                          style: _vm.myShare ? "" : "width:16%",
                          on: {
                            click: function($event) {
                              return _vm.changeUpDownOrder(2)
                            }
                          }
                        },
                        [
                          _vm.pathJson.length < 1
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("language.shares.sharedOn"))
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("language.common.dateModified"))
                                )
                              ]),
                          _vm._v(" "),
                          _vm.index == 2
                            ? _c("div", {
                                staticClass: "icon-util narrow-position-two",
                                class: _vm.upShow
                                  ? "file-up-narrow"
                                  : "file-down-narrow"
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _vm.myShare
                        ? _c(
                            "td",
                            {
                              staticClass: "cloud-td-two",
                              staticStyle: { "text-align": "center" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.shares.allowedTo"))
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.isLoading,
                      expression: "isLoading"
                    }
                  ],
                  attrs: { id: "shareBox" }
                },
                [
                  _vm.nowTableData.length > 0
                    ? _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
                        _c(
                          "table",
                          {
                            directives: [
                              {
                                name: "infinite-scroll",
                                rawName: "v-infinite-scroll",
                                value: _vm.loadTableData,
                                expression: "loadTableData"
                              }
                            ],
                            staticStyle: { width: "100%" },
                            attrs: {
                              border: "0",
                              "infinite-scroll-delay": "0",
                              cellpadding: "0",
                              cellspacing: "0"
                            }
                          },
                          _vm._l(_vm.nowTableData, function(item, index) {
                            return _c(
                              "tr",
                              {
                                key: index,
                                staticClass: "table-tr",
                                class: [
                                  _vm.selectItemArr.includes(item)
                                    ? "tr-back-ground"
                                    : "",
                                  _vm.tableHoverItem === item
                                    ? "table-tr-hover"
                                    : "",
                                  item.isCancel === "yes" ? "disable-tr" : ""
                                ],
                                staticStyle: { "line-height": "25px" },
                                on: {
                                  mouseout: function($event) {
                                    _vm.tableHoverItem = null
                                  },
                                  mouseover: function($event) {
                                    _vm.tableHoverItem = item
                                  },
                                  dblclick: function($event) {
                                    $event.stopPropagation()
                                    return _vm.dblclickShare(item)
                                  },
                                  contextmenu: function($event) {
                                    $event.preventDefault()
                                    return _vm.shareRightMenuOpen($event, item)
                                  },
                                  click: function($event) {
                                    return _vm.addTableCheck(item, true)
                                  }
                                }
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "cloud-td-one-share",
                                    style: _vm.myShare ? "" : "width:52%"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "tr-check-box",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.addTableCheck(
                                              item,
                                              false
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "icon-util icon-tr-position",
                                          class: _vm.selectItemArr.includes(
                                            item
                                          )
                                            ? "check-small"
                                            : "nocheck-small"
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass:
                                        "small-file share-name-position share-file-position",
                                      class: _vm.getFileImg(item),
                                      staticStyle: { "margin-top": "8px" }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "share-name-position file-name",
                                        on: {
                                          dblclick: function($event) {
                                            $event.stopPropagation()
                                            return _vm.dblclickShare(item)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "name-edit-div-share",
                                            class: {
                                              "disable-tr":
                                                item.isCancel === "yes"
                                            },
                                            attrs: { title: item.fileName }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("ellipsis")(
                                                  item.fileName
                                                )
                                              ) + "\n                "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "cloud-td-two",
                                    style: _vm.myShare ? "" : "width:16%"
                                  },
                                  [_vm._v(_vm._s(_vm.getItemType(item.type)))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "cloud-td-two",
                                    style: _vm.myShare ? "" : "width:16%"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatByte")(item.fileSize)
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "cloud-td-two",
                                    style: _vm.myShare ? "" : "width:16%"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("transferTime")(item.createTime)
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.myShare
                                  ? _c(
                                      "td",
                                      {
                                        staticClass: "cloud-td-two",
                                        style: _vm.myShare ? "" : "width:16%"
                                      },
                                      [
                                        _c("MySwitch", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                item.fileType === "folder" &&
                                                item.id &&
                                                item.pathJson &&
                                                item.isUpload != undefined,
                                              expression:
                                                "item.fileType==='folder'&&item.id&&item.pathJson&&item.isUpload!=undefined"
                                            }
                                          ],
                                          attrs: { shareId: item.id },
                                          model: {
                                            value: item.isUpload,
                                            callback: function($$v) {
                                              _vm.$set(item, "isUpload", $$v)
                                            },
                                            expression: "item.isUpload"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    : _c("div", { staticClass: "list-null" }, [
                        _vm.myShare
                          ? _c("div", [
                              _c("p", { staticClass: "list-null-title" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("language.shares.shareNull"))
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "list-null-tips share-color" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("language.shares.shareNullTips")
                                    )
                                  )
                                ]
                              )
                            ])
                          : _c("div", [
                              _c("p", { staticClass: "list-null-title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.shares.savedShareNull")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "list-null-tips share-color" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "language.shares.savedShareNullTips"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                      ])
                ],
                1
              )
            ])
          : _c("div", { staticClass: "grid-list" }, [
              _c("div", [
                _c(
                  "table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { border: "0", cellpadding: "0", cellspacing: "0" }
                  },
                  [
                    _c("tr", { staticClass: "table-th" }, [
                      _c(
                        "td",
                        {
                          staticClass: "cloud-td-one-share",
                          style: _vm.myShare ? "" : "width:52%",
                          on: {
                            click: function($event) {
                              return _vm.changeUpDownOrder(0)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "tr-check-box",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.selectAll()
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "icon-util icon-tr-position",
                                class: this.isAllSelected
                                  ? "check-small"
                                  : "nocheck-small"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "th-span" }, [
                            _vm._v(_vm._s(_vm.$t("language.common.fileName")))
                          ]),
                          _vm._v(" "),
                          _vm.index == 0
                            ? _c("div", {
                                staticClass:
                                  "icon-util file-narrow-position narrow-position",
                                class: _vm.upShow
                                  ? "file-up-narrow"
                                  : "file-down-narrow"
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "cloud-td-two",
                          style: _vm.myShare ? "" : "width:16%",
                          on: {
                            click: function($event) {
                              return _vm.changeUpDownOrder(3)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("language.common.type")))
                          ]),
                          _vm._v(" "),
                          _vm.index == 3
                            ? _c("div", {
                                staticClass: "icon-util narrow-position-two",
                                class: _vm.upShow
                                  ? "file-up-narrow"
                                  : "file-down-narrow"
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "cloud-td-two",
                          style: _vm.myShare ? "" : "width:16%",
                          on: {
                            click: function($event) {
                              return _vm.changeUpDownOrder(1)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("language.common.size")))
                          ]),
                          _vm._v(" "),
                          _vm.index == 1
                            ? _c("div", {
                                staticClass: "icon-util narrow-position-two",
                                class: _vm.upShow
                                  ? "file-up-narrow"
                                  : "file-down-narrow"
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "cloud-td-two",
                          style: _vm.myShare ? "" : "width:16%",
                          on: {
                            click: function($event) {
                              return _vm.changeUpDownOrder(2)
                            }
                          }
                        },
                        [
                          _vm.pathJson.length < 1
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("language.shares.sharedOn"))
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("language.common.dateModified"))
                                )
                              ]),
                          _vm._v(" "),
                          _vm.index == 2
                            ? _c("div", {
                                staticClass: "icon-util narrow-position-two",
                                class: _vm.upShow
                                  ? "file-up-narrow"
                                  : "file-down-narrow"
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _vm.myShare
                        ? _c(
                            "td",
                            {
                              staticClass: "cloud-td-two",
                              staticStyle: { "text-align": "center" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.shares.allowedTo"))
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.isLoading,
                      expression: "isLoading"
                    }
                  ],
                  attrs: { id: "fileGrid" }
                },
                [
                  _vm.nowTableData.length > 0
                    ? _c(
                        "el-scrollbar",
                        { staticStyle: { height: "100%" } },
                        _vm._l(_vm.nowTableData, function(item, index) {
                          return _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "infinite-scroll",
                                  rawName: "v-infinite-scroll",
                                  value: _vm.loadTableData,
                                  expression: "loadTableData"
                                }
                              ],
                              key: index,
                              staticClass: "grid-lattice",
                              attrs: { "infinite-scroll-delay": "0" },
                              on: {
                                contextmenu: function($event) {
                                  $event.preventDefault()
                                  return _vm.shareRightMenuOpen($event, item)
                                },
                                click: function($event) {
                                  _vm.dblclickShare(item),
                                    (_vm.rightMenuShow = false)
                                },
                                mouseover: function($event) {
                                  ;(_vm.gridHoverIndex = index),
                                    (_vm.tableHoverItem = item)
                                },
                                mouseout: function($event) {
                                  _vm.gridHoverIndex = -1
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "grid-all",
                                  class: [
                                    _vm.gridHoverIndex === index
                                      ? "grid-hover"
                                      : ""
                                  ]
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        height: "25Px",
                                        width: "25Px"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.addTableCheck(item, false)
                                        }
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "icon-util grid-icon-positon",
                                        class: _vm.selectItemArr.includes(item)
                                          ? "check-small"
                                          : "nocheck-small"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "grid-position" }, [
                                    _c("div", {
                                      staticClass: "large-file-type ",
                                      class: item.dir
                                        ? "large-" +
                                          _vm.matchfolderType(item.docType) +
                                          " large-folder-position"
                                        : "large-" +
                                          _vm.matchfileType(item.fileName)
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "grid-name",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                        },
                                        mouseover: function($event) {
                                          $event.stopPropagation()
                                          _vm.gridHoverIndex = -1
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          ref: "gridName",
                                          refInFor: true,
                                          staticClass: "grid-name-children",
                                          class: {
                                            "disable-tr":
                                              item.isCancel === "yes"
                                          },
                                          attrs: { title: item.fileName }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("ellipsisOther")(
                                                item.fileName
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          ref: "gridInputName",
                                          refInFor: true,
                                          staticClass: "grid-outclass"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.inputValue,
                                                expression: "item.inputValue"
                                              }
                                            ],
                                            staticClass: "grid-edit-input",
                                            domProps: {
                                              value: item.inputValue
                                            },
                                            on: {
                                              focus: _vm.onfocusEvent,
                                              blur: function($event) {
                                                return _vm.submitName(
                                                  $event,
                                                  item,
                                                  index
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  item,
                                                  "inputValue",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "grid_edit_icon" },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "icon-util grid-name-sure",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.submitName(
                                                      $event,
                                                      item,
                                                      index
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "icon-util grid-name-cancel",
                                                on: {
                                                  mousedown: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.cancelEditName(
                                                      $event,
                                                      item,
                                                      index
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.nowTableData.length == 0 && !_vm.isLoading
                    ? _c("div", { staticClass: "list-null" }, [
                        _vm.myShare
                          ? _c("div", [
                              _c("p", { staticClass: "list-null-title" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("language.shares.shareNull"))
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "list-null-tips share-color" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("language.shares.shareNullTips")
                                    )
                                  )
                                ]
                              )
                            ])
                          : _c("div", [
                              _c("p", { staticClass: "list-null-title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.shares.savedShareNull")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "list-null-tips share-color" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "language.shares.savedShareNullTips"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                      ])
                    : _vm._e()
                ],
                1
              )
            ]),
        _vm._v(" "),
        _vm.shareRightMenuShow
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "clickoutside",
                    rawName: "v-clickoutside",
                    value: _vm.shareRightMenuClose,
                    expression: "shareRightMenuClose"
                  }
                ],
                staticClass: "right-menus-choose",
                attrs: { id: "shareRightMenu" },
                on: {
                  contextmenu: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.myShare,
                        expression: "myShare"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.judgeShowRightMenu("cancel"),
                            expression: "judgeShowRightMenu('cancel')"
                          }
                        ],
                        staticClass: "more-item-choose",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.cancelShareDialgOpen()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "item-position cancel preview-position"
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("language.common.cancel")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.judgeShowRightMenu("edit_share"),
                            expression: "judgeShowRightMenu('edit_share')"
                          }
                        ],
                        staticClass: "more-item-choose",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.shareDialgOpen()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass:
                            "item-position edit-share preview-position"
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("language.common.editShare")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.judgeShowRightMenu("download"),
                            expression: "judgeShowRightMenu('download')"
                          }
                        ],
                        staticClass: "more-item-choose",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.download($event)
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass:
                            "item-position down-load preview-position"
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("language.common.download")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.judgeShowRightMenu("preview"),
                            expression: "judgeShowRightMenu('preview')"
                          }
                        ],
                        staticClass: "more-item-choose",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.previewPageShow()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "item-position preview preview-position"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "menu-txt" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.preview")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showToSource("to_source"),
                            expression: "showToSource('to_source')"
                          }
                        ],
                        staticClass: "more-item-choose",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toSource()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "item-position copy-to preview-position"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "menu-txt" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.toSource")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.judgeShowRightMenu("to_share"),
                            expression: "judgeShowRightMenu('to_share')"
                          }
                        ],
                        staticClass: "more-item-choose",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.goTo()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "item-position copy-to preview-position"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "menu-txt" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.toShare")))
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.saveShare,
                        expression: "saveShare"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.judgeShowRightMenu("copy_to"),
                            expression: "judgeShowRightMenu('copy_to')"
                          }
                        ],
                        staticClass: "more-item-choose",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.copyToDialogShow()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "item-position copy-to preview-position"
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("language.common.copyTo")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.judgeShowRightMenu("download"),
                            expression: "judgeShowRightMenu('download')"
                          }
                        ],
                        staticClass: "more-item-choose",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.download($event)
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass:
                            "item-position down-load preview-position"
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("language.common.download")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.judgeShowRightMenu("preview"),
                            expression: "judgeShowRightMenu('preview')"
                          }
                        ],
                        staticClass: "more-item-choose",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.previewPageShow()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "item-position preview preview-position"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "menu-txt" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.preview")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.judgeShowRightMenu("copy"),
                            expression: "judgeShowRightMenu('copy')"
                          }
                        ],
                        staticClass: "more-item-choose",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.copyFile($event)
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "item-position copy preview-position"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "menu-txt" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.copy")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.judgeShowRightMenu("remove"),
                            expression: "judgeShowRightMenu('remove')"
                          }
                        ],
                        staticClass: "more-item-choose",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.cancelShare()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "item-position remove preview-position"
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("language.leftBanner.remove")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.judgeShowRightMenu("copy_link"),
                            expression: "judgeShowRightMenu('copy_link')"
                          }
                        ],
                        staticClass: "more-item-choose",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.copy($event)
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass:
                            "item-position copy-link preview-position"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "menu-txt" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.copyLink")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.judgeShowRightMenu("to_share"),
                            expression: "judgeShowRightMenu('to_share')"
                          }
                        ],
                        staticClass: "more-item-choose",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.goTo()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "item-position copy-to preview-position"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "menu-txt" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.toShare")))
                        ])
                      ]
                    )
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "selectInfo-footer" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.myShare,
                  expression: "myShare"
                }
              ],
              staticClass: "select-Info"
            },
            [
              _vm._v(
                _vm._s(_vm.selectItemArr.length) +
                  "/" +
                  _vm._s(_vm.shareTableData.length) +
                  " " +
                  _vm._s(_vm.$t("language.common.itemsSelected")) +
                  " "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.saveShare,
                  expression: "saveShare"
                }
              ],
              staticClass: "select-Info"
            },
            [
              _vm._v(
                _vm._s(_vm.selectItemArr.length) +
                  "/" +
                  _vm._s(_vm.savedShareTableData.length) +
                  " " +
                  _vm._s(_vm.$t("language.common.itemsSelected")) +
                  " "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.myShare,
                  expression: "myShare"
                }
              ],
              staticClass: "select-Info"
            },
            [
              _vm._v(
                _vm._s(
                  _vm._f("formatByte")(_vm._f("getAllBytes")(_vm.selectItemArr))
                ) +
                  "/" +
                  _vm._s(
                    _vm._f("formatByte")(
                      _vm._f("getAllBytes")(_vm.shareTableData)
                    )
                  )
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.saveShare,
                  expression: "saveShare"
                }
              ],
              staticClass: "select-Info"
            },
            [
              _vm._v(
                _vm._s(
                  _vm._f("formatByte")(_vm._f("getAllBytes")(_vm.selectItemArr))
                ) +
                  "/" +
                  _vm._s(
                    _vm._f("formatByte")(
                      _vm._f("getAllBytes")(_vm.savedShareTableData)
                    )
                  )
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.snapTaskIconShow,
                  expression: "snapTaskIconShow"
                }
              ],
              staticClass: "icon scaling-open scaling-open-position",
              on: {
                click: function($event) {
                  return _vm.snapTasksOpen()
                }
              }
            },
            [
              _c("snapTaskDialog", {
                ref: "snapTaskDialog",
                on: {
                  cancel: function($event) {
                    return _vm.cancelUpload($event)
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("shareDialog", { ref: "shareDialog" }),
      _vm._v(" "),
      _c("cancelShareDialog", { ref: "cancelShareDialog" }),
      _vm._v(" "),
      _c("copyToDialog", { ref: "copyToDialog" }),
      _vm._v(" "),
      _c("fileExistDialog", { ref: "fileExistDialog" }),
      _vm._v(" "),
      _c("upgradeNewDialog", { ref: "upgradeNewDialog" }),
      _vm._v(" "),
      _c("detailedProgrssDialog", { ref: "detailedProgrss" }),
      _vm._v(" "),
      _c("cancelAllDialog", { ref: "cancelAllDialog" }),
      _vm._v(" "),
      _c("retryFailedDialog", { ref: "retryFailedDialog" }),
      _vm._v(" "),
      _c("remindBindEmailDialog", { ref: "remindBindEmailDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bc7cc3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bc7cc3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/shares.vue
// module id = null
// module chunks = 